// Progress ring (the daily-goal dial). Ported from the wireframe.
export function Ring({
  pct, big, sm, tone = 'good', size = 104,
}: { pct: number; big: string; sm?: string; tone?: 'good' | 'amber'; size?: number }) {
  const r = 44;
  const c = 2 * Math.PI * r;
  const off = c * (1 - Math.max(0, Math.min(100, pct)) / 100);
  const stroke = tone === 'amber' ? 'var(--progress-time)' : 'var(--progress-good)';
  return (
    <svg width={size} height={size} viewBox="0 0 104 104" role="img" aria-label={`${big} ${sm ?? ''}`}>
      <circle cx="52" cy="52" r={r} fill="none" stroke="var(--track)" strokeWidth="9" />
      <circle
        cx="52" cy="52" r={r} fill="none" stroke={stroke} strokeWidth="9" strokeLinecap="round"
        style={{ strokeDasharray: c, strokeDashoffset: off, transform: 'rotate(-90deg)', transformOrigin: '50% 50%' }}
      />
      <text x="52" y="52" textAnchor="middle" dominantBaseline="middle"
        style={{ font: '800 22px var(--font-mono)', fill: 'var(--brand-ink)' }}>{big}</text>
      {sm && (
        <text x="52" y="70" textAnchor="middle"
          style={{ font: '600 9px var(--font-sans)', fill: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '.5px' }}>{sm}</text>
      )}
    </svg>
  );
}
